import api from "../../../services/api";

const getOwnerShip = ({ commit }) => {
  return new Promise((resolve, reject) => {
    api.get("/master/ownership").then(
      response => {
        const res = response.data;
        resolve(response);
        if (res.status) {
          commit("SET_RESULTOWNERSHIP", res.data);
        }
      },
      error => {
        reject(error);
      }
    );
  });
};

const insertMasterOwnerShip = ({ state }) => {
  return new Promise((resolve, reject) => {
    if (state.tempMasterOwnerShip.id) {
      api
        .put("/master/ownership/" + state.tempMasterOwnerShip.id, {
          ...state.tempMasterOwnerShip,
          id: undefined
        })
        .then(
          response => {
            resolve(response);
          },
          error => {
            reject(error);
          }
        );
    } else {
      api.post("/master/ownership", state.tempMasterOwnerShip).then(
        response => {
          resolve(response);
        },
        error => {
          reject(error);
        }
      );
    }
  });
};

const deleteMasterOwnerShip = ({ state }) => {
  return new Promise((resolve, reject) => {
    api.delete("/master/ownership/" + state.idMasterOwnerShip).then(
      response => {
        resolve(response);
      },
      error => {
        reject(error);
      }
    );
  });
};

export default {
  getOwnerShip,
  insertMasterOwnerShip,
  deleteMasterOwnerShip
};
